import React from "react"
import styled from "styled-components"
import Parser from "html-react-parser"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"

import Typography from "@material-ui/core/Typography"

import * as theme from "../../../theme"

const SpecsTable = ({ columns }) => {
  return (
    <Container>
      {!!columns &&
        columns.map((column, index) => {
          return (
            <Column key={index}>
              {column.table_column.map((item, index) => {
                return (
                  <TableContainer key={index}>
                    {!!item.table_headline && (
                      <StyledTable>
                        <Thead>
                          <Tr>
                            <Th className="table-title">
                              <TableTitle variant="subtitle2">
                                {item.table_headline}
                              </TableTitle>
                            </Th>
                          </Tr>
                        </Thead>
                      </StyledTable>
                    )}
                    <StyledTable className="main-table">
                      <Thead>
                        <Tr>
                          {!!item.table.header &&
                            item.table.header.map((cell, index) => {
                              return (
                                <Th key={index}>
                                  <TableHead variant="subtitle2">
                                    {cell.c}
                                  </TableHead>
                                </Th>
                              )
                            })}
                        </Tr>
                      </Thead>
                      <Tbody>
                        {!!item.table.body &&
                          item.table.body.map((row, index) => {
                            return (
                              <Tr key={index}>
                                {!!row &&
                                  row.map((cell, index) => {
                                    return (
                                      <Td key={index}>
                                        <TableBody variant="body1">
                                          {Parser(cell.c)}
                                        </TableBody>
                                      </Td>
                                    )
                                  })}
                              </Tr>
                            )
                          })}
                      </Tbody>
                    </StyledTable>
                    {!!item.table_footer && (
                      <TableFooter>{item.table_footer}</TableFooter>
                    )}
                  </TableContainer>
                )
              })}
            </Column>
          )
        })}
    </Container>
  )
}

export default SpecsTable

const TableContainer = styled.div`
  width: 100%;
`

const Container = styled.section`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  @media (min-width: 800px) {
    flex-direction: row;
  }
`
const Column = styled.div`
  @media (max-width: 799px) {
    .main-table {
      margin-bottom: 30px;
    }
  }
  @media (min-width: 800px) {
    padding-left: 20px;
    padding-right: 20px;
    &:first-of-type {
      padding-left: 0;
    }
    &:lst-of-type {
      padding-right: 0;
    }
    margin-bottom: 30px;
  }
  width: 100%;
`
const TableTitle = styled(Typography)`
  color: white;
  margin-bottom: 0;
  text-align: center;
  text-transform: uppercase;
`

const TableFooter = styled(Typography)`
  && {
    text-align: center;
    padding: 5px 0;
    margin-bottom: 20px;
  }
`

const TableHead = styled(Typography)`
  margin: 0;
`
const TableBody = styled(Typography)`
  padding: 5px 0;
`

const StyledTable = styled(Table)`
  .tdBefore {
    display: none;
  }
  table-layout: fixed;
  width: 100%;
  thead {
    color: white;
    background: ${theme.color.lightgreen};
    text-transform: uppercase;

    tr {
      .table-title {
        border: 1px solid ${theme.color.primary};
        background: ${theme.color.primary};
      }
      th {
        border: 1px solid ${theme.color.darkGrey};
        text-align: center;
        padding: 10px 0;
        background: ${theme.color.darkGrey};
      }
    }
  }
  tbody {
    tr {
      &:nth-child(odd) {
        background: #eeeeee;
      }
      border: 1px solid lightgrey;
      td {
        /* width: 50%; */
        text-align: center;
      }
    }
  }
`
